<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1.titulo(v-if="!processo") Voltar Caixa Processo
    div.box-titulo(v-else)
      el-button.botao-voltar(
            type="primary"
            @click="voltar"
          )
            span.center
              i.fas.fa-chevron-left
      span.span-titulo(v-if="processo") {{ `Processo ${numProcesso}:` }}
    el-row.caixa-pesquisa(:gutter="30", v-if="!processo")
      el-col(:span="8")
          app-label(label="Digite o N° do Processo:")
          el-input(
            placeholder="N° do Processo",
            class="input-with-select",
            v-model="numProcesso"
          )
            el-button.color-default(
              slot="append",
              icon="el-icon-search",
              id='botao-pesquisar',
              @click="pesquisar"
            )
    el-row.caixa-pesquisa(:gutter="30", v-else)
      el-col.col-principal(:span="8")
        card-processo(
          :idProcesso="processo.id",
          :nomeInteressado="processo.nomeRazaoSocialInteressado",
          :statusProcesso="processo.status",
          :numeroProcesso="processo.numeroProcesso",
          :cpfCnpjInteressado="processo.cpfCnpjInteressado",
          :setorProcesso="processo.setor",
          :opcoesAcoes="true",
          :numeroProtocolo="processo.numeroProtocolo",
          :tipoCodigoProcesso="processo.tipo.codigo",
          :usuario="processo.usuario"
        )
        app-label(label="Motivo da mudança:")
        app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="mensagem",
            ref="editorTexto"
          )
        div.voltar-processo
          div
            app-label(label="Voltar Caixa Processo:", style="margin-top: 20px")
            el-select.input(
              placeholder="Selecione a caixa",
              class="input-with-select",
              v-model="taskSelecionada",
              class="select"
            )
              el-option(
                v-for="task, index in tasks",
                :key="index",
                :label="task.name",
                :value="index"
              )
            el-button(
              type="primary"
              @click="voltarProcesso"
            )
              span.center
                b Mover &nbsp
                i.fas.fa-chevron-right
</template>
<script>
import AppLabel from '@/components/AppLabel'
import {buscarProcesso, buscarTasks, voltarProcesso} from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import CardProcesso from './components/CardProcesso.vue'

export default {
  components: {
    AppLabel,
    AppEditorTexto,
    CardProcesso
  },
  data () {
    return {
      numProcesso: '',
      mensagem: '',
      processo: null,
      tasks: null,
      taskSelecionada: null
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {
    async pesquisar () {
      if (!this.numProcesso || this.numProcesso === '') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      else {
        const response = await buscarProcesso(this.numProcesso)
        const responseTask = await buscarTasks(response?.id)
        if (response && responseTask) {
          this.processo = response
          this.tasks = responseTask
        } else {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            'Erro ao buscar o Processo, verifique o N° do Processo')
        }
      }
    },
    onTextChange (text) {
      this.mensagem = text
    },
    async voltarProcesso () {
      const mensagem = this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
      if (typeof this.taskSelecionada !== 'number') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Selecione a caixa')
      else if (mensagem.length < 10) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O campo "Motivo da mudança" deve estar preenchido com no minímo 10 caracteres')
      else {
        const response = await voltarProcesso(this.processo.id, this.taskSelecionada, this.mensagem)
        if (!response) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Erro ao voltar processo, verifique sua conexão')
        else {
          await this.pesquisar()
          this.mensagem = ''
          this.taskSelecionada = null
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo retornou')
        }
      }
    },
    voltar () {
      this.processo = null
      this.tasks = null
      this.taskSelecionada = null
      this.numProcesso = ''
      this.mensagem = ''
    }
  }
}
</script>
<style lang="scss" scoped>
    $font-size-small: 12px;

    .color-default {
      color: #009d64 !important;
      font-size: 16px;
    }
    .caixa-pesquisa {
      margin-bottom: 10px;
    }
    .titulo {
      margin-top: 0;
    }
    .span-titulo {
      margin-top: 0;
      margin-bottom: 3px;
      font-size: 32px;
      margin-left: 20px;
    }
    .box-processo {
      min-width: 700px;
      padding-left: 3px;
      padding-right: 3px;
    }
    .select {
      margin-right: 20px;
    }
    .span-style {
      font-weight: normal;
    }
    .botao-voltar {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center {
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
    .box-titulo {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .col-principal {
      width: 100%;
      min-width: 685px;
    }
    .voltar-processo {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/VoltarCaixaProcessos.vue